import { getMappedEvents } from '../utils/getMappedEvents';

const EVENTS = ['audioDownloadUpgradeClick', 'audioUpgradeModalShown', 'audioUpgradeChoosePlanModalClick'] as const;

export const audioDownloadEvents = getMappedEvents([...EVENTS], {
  shouldSendSubscriptionData: true,
  shouldSendRaskTTSData: true,
});
